import React, { useEffect, useState } from "react";
import _ from "lodash";
import PodcastButton from "./PodcastButton";
import { isTypePodcast, validatePodcastObject } from "../lib/podcastHelper";

const Podcast = ({ gatewayInfo }) => {
  const [isPodcast, setIsPodcast] = useState(false);
  const [podcast, setPodcast] = useState({});

  useEffect(() => {
    setIsPodcast(isTypePodcast(gatewayInfo["new-user-title"]));
    setPodcast(validatePodcastObject(gatewayInfo["pdf-_description"]));
  }, []);

  return isPodcast && !_.isEmpty(podcast) ? (
    <div className="podcastContainer">
      <div className="podcastTitle">
        Select a podcast player below to tune in.
      </div>
      <div className="podcastButtons">
        {Object.keys(podcast).map((key) => {
          return <PodcastButton key={key} type={key} value={podcast[key]} />;
        })}
      </div>
    </div>
  ) : null;
};

export default Podcast;
